export enum ServiceRequestStatus {
  New = 0,
  Processing = 1,
  Completed = 2,
  Error = 3,
  AutomatedNew = 4,
  AutomatedPaid = 5,
  AutomatedPaymentExpired = 6,
  AutomatedPaymentSuspended = 7,
  AutomatedPaymentProcessing = 8,
  AutomatedPaymentRequested = 9
}

export class ServiceRequestStatusHelper {
  static GetCyrilicName(value: ServiceRequestStatus): string {
    switch (value) {
      case ServiceRequestStatus.New:
        return 'Нов';
      case ServiceRequestStatus.Processing:
        return 'Обработва се';
      case ServiceRequestStatus.Completed:
        return 'Завършен';
      case ServiceRequestStatus.Error:
        return 'Грешка';
      case ServiceRequestStatus.AutomatedNew:
        return 'Автоматизиран нов';
      case ServiceRequestStatus.AutomatedPaid:
        return 'Автоматизиран платен';
      case ServiceRequestStatus.AutomatedPaymentExpired:
        return 'Автоматизиран изтекло плащане';
      case ServiceRequestStatus.AutomatedPaymentSuspended:
        return 'Автоматизиран спряно плащане';
      case ServiceRequestStatus.AutomatedPaymentProcessing:
        return 'Автоматизиран обработка на плащане';
      case ServiceRequestStatus.AutomatedPaymentRequested:
        return 'Заявено';
      default:
        return 'Неизвестен статус';
    }
  }
}
